(function($) {

    function set_height(){
        var h = $('.2_col_tti .text-container').height();
        $('.2_col_tti .text-container').css('height', h);
    }

    $(document).ready(function() {    

    set_height();


    });


})
(jQuery);